var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrendSymbolUp = function SvgTrendSymbolUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 7",
    stroke: "#000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.828 4 4.5 1.67 2.17 4",
    strokeWidth: 2.354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgTrendSymbolUp;